import { API } from "../../cache";
import { ApiError, parseErrorResponse } from "./errors";

const DEFAULT_HEADERS = {
  Accept: "application/json",
};

function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}

function buildUrl(path, query) {
  const cleanPath = String(path || "").startsWith("/") ? path : `/${path || ""}`;
  const url = new URL(`${API}${cleanPath}`);
  if (query && typeof query === "object") {
    Object.entries(query).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (Array.isArray(value)) {
        value.forEach((v) => url.searchParams.append(key, String(v)));
      } else {
        url.searchParams.set(key, String(value));
      }
    });
  }
  return url.toString();
}

async function request(path, options = {}) {
  const {
    method = "GET",
    query,
    headers = {},
    body,
    credentials = "include",
    ...rest
  } = options;

  const url = buildUrl(path, query);
  const finalHeaders = { ...DEFAULT_HEADERS, ...headers };
  let finalBody = body;

  if (body && typeof body === "object" && !isFormData(body) && !(body instanceof Blob)) {
    finalHeaders["Content-Type"] = finalHeaders["Content-Type"] || "application/json";
    finalBody = JSON.stringify(body);
  }

  const res = await fetch(url, {
    method,
    credentials,
    headers: finalHeaders,
    body: finalBody,
    ...rest,
  });

  if (!res.ok) {
    const parsed = await parseErrorResponse(res);
    throw new ApiError(parsed.message, {
      status: res.status,
      payload: parsed.payload,
      method,
      url,
    });
  }

  if (res.status === 204) return null;

  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("application/json")) return res.json();
  return res.text();
}

export const httpClient = {
  request,
  get(path, options = {}) {
    return request(path, { ...options, method: "GET" });
  },
  post(path, body, options = {}) {
    return request(path, { ...options, method: "POST", body });
  },
  patch(path, body, options = {}) {
    return request(path, { ...options, method: "PATCH", body });
  },
  put(path, body, options = {}) {
    return request(path, { ...options, method: "PUT", body });
  },
  delete(path, options = {}) {
    return request(path, { ...options, method: "DELETE" });
  },
};
